module.exports = __webpack_public_path__ + "static/media/trello.4b0ec275.svg";